export default __webpack_public_path__ + "static/media/dashboard_xn_error.54d8e93a.svg";